import React, { useState } from "react";

const impactsData = [
  {
    id: 1,
    title: "Helping Low-Income Households Save Up to 30% on Energy Costs",
    description: `One of our key goals is to alleviate the financial burden faced by low-income households when it comes to accessing clean cooking energy. Through our innovative Waste-to-Fuel scheme, we enable families to exchange segregated recyclables for credit points that can be redeemed for LPG cylinders or other energy-related products and services. This unique approach not only provides an alternative payment method but also helps households save up to 30% on their energy costs. By reducing the financial barriers to clean cooking energy, we empower communities to allocate their limited resources towards other essential needs, such as education, healthcare, and improving their overall quality of life.`,
  },
  {
    id: 2,
    title: "Reducing the Nation's Carbon Footprint from Cooking Activities",
    description: `Recognizing the detrimental impact of traditional biomass fuels on the environment, Guerate Energy is committed to reducing the nation's carbon footprint from cooking activities. By promoting the adoption of clean cooking gas (LPG) as an alternative to firewood, charcoal, and kerosene, we contribute to a substantial reduction in greenhouse gas emissions and deforestation. Our efforts not only mitigate environmental degradation but also improve air quality in households, reducing the risk of respiratory illnesses and other health issues associated with indoor air pollution.`,
  },
];

const Impacts = () => {
  // const [readMore, setReadMore] = useState({});

  // const toggleReadMore = (id) => {
  //   setReadMore((prevState) => ({
  //     ...prevState,
  //     [id]: !prevState[id],
  //   }));
  // };

  const highlightText = (text, highlight, className) => {
    const parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={index} className={className}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  // const highlightBoldText = (text) => {
  //   const parts = text.split("Save Up to 30% on Energy Costs");
  //   return (
  //     <>
  //       {parts[0]}
  //       <span className="font-bold">Save Up to 30% on Energy Costs</span>
  //       {parts[1]}
  //     </>
  //   );
  // };

  return (
    <div
      style={{
        backgroundImage: `url('/images/bg.avif')`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div className="bg-[#01579b] w-full py-8 h-full bg-opacity-50">
        <div className="w-[90%] flex flex-col gap-7 mx-auto">
          <h1 className="text-4xl md:text-6xl text-[#f46524]">
            Desired Impacts
          </h1>

          <div className="text-[#fff] grid grid-cols-1 md:grid-cols-2 gap-7">
            {impactsData.map((impact) => (
              <div
                key={impact.id}
                className={`flex flex-col gap-4 shadow-2xl p-4 bg-white text-black rounded-md hover:shadow-sm transition-shadow ${
                  impact.id === 2 ? "h-fit" : ""
                }`}
              >
                <h1 className="text-2xl md:text-4xl">
                  {highlightText(
                    impact.title,
                    "Save Up to 30% on Energy Costs",
                    "text-green-600 font-semibold"
                  )}
                </h1>
                {/* <p>
                  {readMore[impact.id] ? (
                    <>
                      {highlightText(
                        impact.description,
                        "Guerate Energy",
                        "text-green-600 font-semibold"
                      )}
                    </>
                  ) : (
                    <>
                      {highlightText(
                        impact.description.substring(0, 100),
                        "Guerate Energy",
                        "text-green-600 font-semibold"
                      )}
                      ...
                    </>
                  )}
                  <button
                    onClick={() => toggleReadMore(impact.id)}
                    className="text-blue-500 ml-2"
                  >
                    {readMore[impact.id] ? "Read Less" : "Read More"}
                  </button>
                </p> */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impacts;
